import Web3 from "web3";
import { DEFAULT_CHAIN } from "./constant";
import { supportNetwork } from './network';

export const getWeb3 = () => {
  let setRpc = supportNetwork[DEFAULT_CHAIN].rpc;
  return new Web3(setRpc);
}